export const LOAD_ROOT_CATEGORIES = 'load_root_categories';
export const ROOT_CATEGORIES_LOADED = 'set_loaded_categories';
export const LOAD_CATEGORY = 'load_category';
export const CATEGORY_LOADED = 'set_loaded_category';
export const LOAD_SUBCATEGORIES = 'load_subcategories';
export const SUBCATEGORIES_LOADED = 'set_loaded_subcategories';
export const LOAD_ANCESTORS = 'load_ancestors';
export const ANCESTORS_LOADED = 'set_loaded_ancestors';
export const RESET_CATEGORIES = 'reset_categories';
export const SYNC_FAILED = 'categories_sync_has_failed';
export const ROOT_SUB_CATEGORIES_SYNC_FAILED = 'root_sub_categories_sync_failed';
export const LOAD_ROOT_SUB_CATEGORIES = 'load_root_sub_categories';
export const LOADED_ROOT_SUB_CATEGORIES = 'loaded_root_sub_categories';
export const BUILD_ROOT_SUB_CATEGORIES_HIERARCHY = 'build_root_sub_categories_hierarchy';
export const SET_ROOT_SUB_CATEGORIES = 'set_root_sub_categories';
export const RESET_SUB_CATEGORIES_ERROR = 'reset_sub_categories_error';
